import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

interface Props {
  options?: SliderOpts;
}

interface SliderOpts {
  dots: boolean;
  infinite: boolean;
  slidesToShow: number;
  slidesToScroll: number;
  arrows: boolean;
  autoplaySpeed: number;
  autoplay: boolean;
}

const defaultOpts: SliderOpts = {
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplaySpeed: 2500,
  autoplay: true,
};

type Image = {
  id: string;
  path: string;
};

const images: Image[] = [
  { id: '1', path: '/images/workspace-wizard/apply_sample_image.png' },
  { id: '2', path: '/images/workspace-wizard/apply_sample_image.png' },
  { id: '3', path: '/images/workspace-wizard/apply_sample_image.png' },
  { id: '4', path: '/images/workspace-wizard/apply_sample_image.png' },
  { id: '5', path: '/images/workspace-wizard/apply_sample_image.png' },
];

export const ImageSlider: React.FC<Props> = ({ options }) => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => void requestAnimationFrame(() => setHydrated(true)), []);
  if (!hydrated) return null;

  return (
    <Container>
      <Slider {...defaultOpts} {...options}>
        {images.map((image, index) => (
          <div key={`key-image-${image.id}`} style={{ width: '100%', height: '100%', position: 'relative' }}>
            <img src={image.path} alt={`slide-${index}`} />
          </div>
        ))}
      </Slider>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
`;
